import { Text } from "theme-ui";
import { Alert } from "@smerth/gatsby-theme-theme-ui";
import alertData from "../../../../documentation/data/alert.yaml";
import * as React from 'react';
export default {
  Text,
  Alert,
  alertData,
  React
};